import React, { Component, useState } from 'react';
import { Button, Collapse } from 'reactstrap';
import FontAwesome from 'react-fontawesome';
import NonValidatedField from '../NonValidatedField/NonValidatedField';
import ValidatedField from '../ValidatedField/ValidatedField';
import ValidatedCheckbox from '../ValidatedCheckbox/ValidatedCheckbox';
import AutoCompleteField from '../AutoCompleteField/AutoCompleteField';

const Step3 = (props) => {
  const [additionalAddressOpened, setAdditionalAddressOpened] = useState(false);
  return (
      <div>
          <h2>פרטי התקשרות</h2>

          <div className="form-inline">
            <ValidatedField label="דואר אלקטרוני" disabled="disabled" name="privateEmail" type="text" placeholder="דואר אלקטרוני אישי" cols="3" tabIndex="1"/>
            <ValidatedField label="מספר סלולרי" disabled="disabled" name="mobilePhone" type="text" placeholder="מספר סלולרי" cols="3" tabIndex="2"/>
            <NonValidatedField label="טלפון בבית" name="homePhone" type="text" placeholder="טלפון בבית" cols="3" tabIndex="3"/>
            <NonValidatedField label="טלפון בעבודה" name="workPhone" type="text" placeholder="טלפון בעבודה" cols="3" tabIndex="4"/>
          </div>

          <hr />
          <h4>כתובת מגורים ראשית</h4>

          <div className="form-inline">
            <AutoCompleteField name="city" label="עיר" api="GetCities" parentId={null} className="form-control" placeholder="עיר" required={true} cols="3" tabIndex="5"/>
            {props.candidate.city ? <AutoCompleteField name="street" label="רחוב" api="GetStreets" parentId={props.candidate.city.Key} className="form-control" placeholder="רחוב" required={true} cols="3" tabIndex="6"/> : null }
            <NonValidatedField name="otherStreet" label="רחוב אחר" type="text" placeholder="במידה ולא נמצא הרחוב ברשימה" cols="3" tabIndex="7"/>
            
            <ValidatedField label="מספר בית" name="homeNumber" type="text" placeholder="מספר בית" cols="3" tabIndex="8"/>
            <NonValidatedField label="מספר דירה" name="apartmentNumber" type="text" placeholder="מספר דירה" cols="3" tabIndex="9"/>
            <NonValidatedField label="מיקוד" name="zipCode" type="text" placeholder="מיקוד" cols="3" tabIndex="10"/>
          </div>

          <Button color="link" onClick={() => setAdditionalAddressOpened(!additionalAddressOpened)}>
            <h4><FontAwesome name="plus"/> הוספת כתובת</h4>
          </Button>

          <Collapse className="form-inline" isOpen={additionalAddressOpened}>

            <AutoCompleteField name="additionalCity" label="עיר" api="GetCities" parentId={null} className="form-control" placeholder="עיר" hidestar={true} cols="3" tabIndex="11"/>
            {props.candidate.additionalCity ? <AutoCompleteField name="additionalStreet" label="רחוב" api="GetStreets" parentId={props.candidate.additionalCity.Key} className="form-control" placeholder="רחוב" hidestar={true} cols="3" tabIndex="12"/> : null }
            <ValidatedField name="additionalOtherStreet" label="רחוב אחר" type="text" placeholder="במידה ולא נמצא הרחוב ברשימה" cols="3" tabIndex="13" hidestar="true"/>

            <ValidatedField label="מספר בית" name="additionalHomeNumber" type="text" placeholder="מספר בית" cols="3" tabIndex="14" hidestar="true"/>
            <NonValidatedField label="מספר דירה" name="additionalApartmentNumber" type="text" placeholder="מספר דירה" cols="3" tabIndex="15"/>
            <ValidatedField label="מיקוד" name="additionalZipCode" type="text" placeholder="מיקוד" cols="3" tabIndex="16" hidestar="true"/>
        
          </Collapse>
      </div>
  );
};

export default Step3;